import {useFormikContext} from 'formik';
import CustomRadio from '../../../../../components/mazraeKit/customRadio';
import {
  IBankDocsGeneralForm,
  IPersonFormData,
} from '../credit-loan/LoanDocsPage';

// Type guard to check if fieldPrefix refers to a person (not global)
const isPersonPrefix = (
  prefix: keyof IBankDocsGeneralForm,
): prefix is 'self' | 'Guarantor-0' | 'Guarantor-1' => {
  return prefix !== 'global';
};

export const CheckTypeSection = ({
  fieldPrefix,
}: {
  fieldPrefix: keyof IBankDocsGeneralForm;
}) => {
  const {values, setFieldValue} = useFormikContext<IBankDocsGeneralForm>();

  // If fieldPrefix is 'global', return null since checkType doesn't exist on global
  if (!isPersonPrefix(fieldPrefix)) {
    return null;
  }

  const personData = values[fieldPrefix] as IPersonFormData;
  const checkType = personData?.checkType;
  const fieldName = `${fieldPrefix}.checkType`;

  const options = [
    {title: 'چک کاغذی', value: 'paper'},
    {title: 'چک دیجیتال', value: 'digital'},
  ];

  return (
    <div className="mb-4 text-sm">
      <label className="block mb-2">
        نوع چک ضمانت را انتخاب کنید <span className="text-red-600">*</span>
      </label>
      <div className="space-y-2">
        {options.map(item => (
          <CustomRadio
            key={item.value}
            title={item.title}
            value={item.value}
            name={fieldName}
            checked={checkType === item.value}
            onChange={() => setFieldValue(fieldName, item.value)}
          />
        ))}
      </div>
    </div>
  );
};
